import React, { useState } from "react";
import "./ContactPage.css";

const ContactPage = () => {
  const [name, setname] = useState("");
  const [email, setEmail] = useState("");
  const [message, setmessage] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();
    alert(
      `Thank You ${name} for Contacting Us. We will Get Back to You Soon.\n\nYour Mail Id - ${email}.\nYour Message is - ${message}`
    );
    setname("");
    setEmail("");
    setmessage("");
  };

  return (
    <>
      <div className="contactSection">
        <h2>Kontaktiraj nas</h2>
        <div className="contactMap">
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2835.7771172853163!2d18.487721776574325!3d44.70374918385446!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x475c1d005a061eef%3A0x5f1a3d7c44e7700!2sOptika%20ALPHA%20FOCUS!5e0!3m2!1sen!2sba!4v1780149324766!5m2!1sen!2sba"
            width="800"
            height="600"
            allowfullscreen=""
            loading="lazy"
            referrerpolicy="no-referrer-when-downgrade"
            title="uomomap"
          ></iframe>
        </div>
        <div className="contactInfo">
          <div className="contactAddress">
            <div className="address">
              <h3>Radnja u Srebreniku</h3>
              <p>

                Ulica 1. Marta , Srebrenik, 75350
                <br /> Bosnia and Herzegovina
              </p>
              <p>
                optika.alpha@gmail.com
                <br />
                +387603317696
              </p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ContactPage;
